module.exports = __webpack_public_path__ + "static/media/golfer-8-a.abee0a00.png";